import type { TCustomPadding } from '../types';

export const convertPadding = (padding: TCustomPadding) => {
  switch (padding) {
    case 'default':
      return 'md';
    case 'small':
      return 'sm';
    case 'none':
      return 'xs';
    default:
      return padding;
  }
};
